import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import { AppCSS } from "..";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(25, 25, 25, .9)",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9999,
    },
    progress: {
      width: "80vw",
      maxWidth: "280px",
      marginBottom: "20px",
      borderRadius: "10px",
      height: "8px",
      transition: "width 5s ease-in-out",
      "@media (max-width: 640px)": {
        maxWidth: "220px",
        height: "6px",
      },
    },
    bar: {
      backgroundColor: AppCSS.GREEN,
      width: "40px",
    },
    colorPrimary: {
      backgroundColor: AppCSS.GRAY_DARK,
    },
  })
);

interface LoadingProps {
  isLoading?: boolean;
}

const AppLoader: React.FC<LoadingProps> = ({ isLoading = false }) => {
  const classes = useStyles();

  return (
    <div
      style={{
        display: isLoading ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
      }}
      className={classes.root}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          padding: "0 16px",
        }}
      >
        <LinearProgress
          classes={{
            root: classes.progress,
            bar: classes.bar,
            colorPrimary: classes.colorPrimary,
          }}
        />
        <p style={{ color: "white", fontSize: "1.4rem", margin: "0", textAlign: "center" }}>
          Loading...
        </p>
      </div>
    </div>
  );
};

export default AppLoader;
